import { calcStepWidth } from '../../StepFunctions';
import { TitleStepProps } from '../TitleStep';
import styles from './MaterialTitleStep.module.css';
import { useAppSelector } from '../../../hooks';
import FormContext from '../../../Contexts/FormContext';
import { useContext, useMemo } from 'react';
import { selectDependencies, useFormStep } from '../../StepHooks';
import { stringToDraft } from '../../../Utils/DraftFunctions';
import { EurekaDraft } from '../../../@Types/Draft/Draft';
import SmartDraftRenderer from '../../../Shared/SmartDraftRenderer/SmartDraftRenderer';

//**Pendientes a mejorar, esperar antes de enviar, en local (actividades), usar el value envez de el draft en actividades, esperar a que dejen de escribir, optimizar para que use lo que tiene en local y si necesita ahi si pregunte. */

function TitleStep({ step }: TitleStepProps): JSX.Element {
    const { value, onChange } = useFormStep<
        | {
              title?: string | EurekaDraft;
              description?: string | EurekaDraft;
          }
        | undefined
    >(step, {
        defaultValue: undefined,
    });

    const { formStyle } = useAppSelector((state) => state.global);
    const form = useContext(FormContext);

    const widthStats = useAppSelector((state) => state.widthStats);
    const size = step.size ?? form.size.blockNum;

    const title = useMemo(
        () => calcBaseDraft(value?.title ?? step.title), //Usa por defecto lo que venga en el value, pero no escucha cambios
        [step.title]
    );

    const description = useMemo(
        () => calcBaseDraft(value?.description ?? step.description), //Usa por defecto lo que venga en el value, pero no escucha cambios
        [step.description]
    );

    const dependencies = useAppSelector((state) =>
        selectDependencies(state, step.dependencies)
    );

    const values = useMemo(() => {
        const values: Record<string, any> = {};
        for (const { idOriginal, value } of Object.values(dependencies)) {
            values[idOriginal] = value;
        }
        return values;
    }, [dependencies]);

    return (
        <div
            className={styles.container}
            style={{
                color: formStyle.textColor,
                width:
                    widthStats.currentBreakPoint <= size
                        ? '100%'
                        : calcStepWidth(size, form.size),
            }}
        >
            <div
                className={styles.titleLbl}
                style={{
                    textAlign:
                        widthStats.isMobile &&
                        widthStats.currentBreakPoint <= size
                            ? 'center'
                            : 'start',
                }}
            >
                <SmartDraftRenderer
                    draft={title}
                    dependencies={values}
                    property={`${step.stepPath.join('.')}.title`}
                    onChange={(title) => onChange({ ...value, title })}
                />
            </div>

            <div className={styles.descriptionPar}>
                <SmartDraftRenderer
                    draft={description}
                    dependencies={values}
                    margin={title ? '10px 0px' : '0px 0px 5px 0px'}
                    property={`${step.stepPath.join('.')}.description`}
                    onChange={(description) =>
                        onChange({ ...value, description })
                    }
                />
            </div>
        </div>
    );
}
export default TitleStep;

function calcBaseDraft(value: string | EurekaDraft | undefined): EurekaDraft {
    return typeof value === 'string'
        ? (stringToDraft(value) as EurekaDraft)
        : value ?? (stringToDraft('') as EurekaDraft);
}
